<template>
  <div :id="listId" :class="{'showList': active}">
    <li
      v-for="(item, index) in items"
      :id="index"
      :style="(index < limitItems) ? {'display':'list-item'} : {'display': 'none'}"
      :key="index"
    >
   {{ item[nameField] }}
      </li>
    <a
      class="text-primary text-capitalize"
      v-on:click="toggle"
      v-if="items.length > limitItems"
    >
      <span v-if="active">{{ Lang.get('messages.show_less') }}</span>
      <span v-else>{{ Lang.get('messages.show_all') }}</span>
    </a>
  </div>
</template>

<script>
import Lang from "lang.js";
export default {
  name: "ShowMoreList",
  props: {
    listId: { type: [String, Number], required: true },
    items: { type: Array, required: true },
    limitItems: { type: Number, default: 3 },
     nameField: { type: String, default: "name" } // <-- Add this line
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    toggle() {
      this.active = !this.active;
    }
  }
};
</script>

<style scoped>
.showList li {
  display: list-item !important;
}
</style>